import { controls } from "../../controls";

const sv008 = {
  label: "Save Signature",
  pageLabel: "Save Signature",
  starting: true,
  url: "sv008",
  formActions: { edit: { allow: true } },
  pageType: "history",

  form: [
    ...controls.displayText({ label: "Branch", width: "col-sm-2" }),
    ...controls.branch({ defaultValue: "assigned_branch", isRequired: true, star: true, width: "col-sm-2" }),
    ...controls.showData({ data: "branch_display", name: "branch_display", width: "col-sm-2" }),
    ...controls.displayText({ width: "col-sm-6" }),

    ...controls.displayText({ label: "Customer Number", width: "col-sm-2" }),
    ...controls.customerNumber({ width: "col-sm-2" }),
    ...controls.showData({ width: "col-sm-2", data: "customer_number_display" }),
    ...controls.displayText({ width: "col-sm-6" }),

    ...controls.displayText({ star: true, label: "GL Sub Head", width: "col-sm-2" }),
    ...controls.product({
      isRequired: true, width: "col-sm-2",
      sendToServer: {
        dataType: 'product', sendData: [{ varname: 'lastAcNo', fixed: true },
        { varname: 'branch_guid', value: 'branch_guid' }]
      },
      displayData: { descn: "product_code_display", guid: "product_code_guid", producttype: "product_type", glrefid: "product_code", nominationavailable: 'nominees_button', allowchequqbook: 'chequebook_button', atmallow: 'atm_button', MaxAcNo: "last_ac_no" }
    }),
    ...controls.showData({ data: "product_code_display", name: "product_code_display", width: "col-sm-2" }),

    ...controls.displayText({ width: "col-sm-6" }),
    ...controls.displayText({ label: "Account No", width: "col-sm-2" }),
    ...controls.AccountNumber({
      width: "col-sm-2",
      forceRender: true,
      beforeLeave: ["createAcNo"],
      //   onLeave: [
      //     // "checkPAN", "checkMobile", "checkSMS", "checkaadhar", 
      //     "checkLoans", "checkAcClosed", "checkLienMarking", "checkMinBal", "checkRenewal", "checkPremature"], // {type:'check',value:'pan'},{type:'match',value:12000},

      displayData: {
        producttype_guid: "producttype_guid", descn: "account_number_display", account_number_guid: 'account_number_guid', balance: "balance", pendingcharges: 'pending_charges', customer_number: "customer_number", account_code: "account_number", branch_code_guid: "account_branch_guid", product_code_guid: "product_code_guid"
      }
    }),
    ...controls.showData({ data: "account_number_display", width: "col-sm-2" }),



    {
      inputType: "fileupload",

      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      label: "Fileupload",
      name: "signature_photo",
      placeholder: {
        type: "text",
        value: "Upload Sign."
      },
      Bcolor: "success",
      files: [],
      multiple: true
    },
  ]
}
export default sv008;